import { useOutletContext, useSearchParams } from "react-router-dom";
import {
  deleteFinancials,
  getFinancials,
  insertLogs
} from "../../homepurchase.service";
import React, { useEffect, useRef, useState } from "react";
import { Loading } from "app/components";
import { getSessionUserInformation } from "app/utils/utility.service";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { formatNumber } from "app/utils/utility.service";
import { Button } from "primereact/button";
import AddFinancials from "./AddFinancials";
import { formatDate } from "app/utils/utility.service";
import moment from "moment";
import { getSessionClientInformation } from "app/utils/utility.service";
  const initialState = {
    equity_name: "",
    purchase_date: "",
    qty_owned: "",
    purchasePrice: "",
   // current_price: "",
    //percentage_change: "",
    //gain_loss: "",
    projected_growth: ""
  };

const Financials = () => {

  const { data, setData } = useOutletContext(); // Access Parent's state
 
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  let sessionValues =
      clientId && clientId !== "null"
        ? getSessionClientInformation()
        : getSessionUserInformation();
  const clientInfo = getSessionClientInformation();
  if (clientInfo) {
    sessionValues = clientInfo;
  }
  const userId =
  clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [title, setTitle] = useState("");
  const [values, setValues] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [finDetails, setFinDetails] = useState([]);
  const [pdate, setPdate] = useState("");
  
 
  const [financialModal, setFinancialModal] = useState(false);
  const toast = useRef();
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };

  useEffect(() => {
    setIsLoading(true);
  
    fetchFinancials();
  }, []);


  const fetchFinancials = async () => {

    let list = await getFinancials(userId);
    if (list!= null && list.length >0) {
      setIsLoading(false);
     
      list.map((li, index) => (li.srNo = index + 1));
      
      setFinDetails(list);
      setData({ list:list,purchasePrice: list[0]?.purchasePrice,addressOne: list[0]?.equity_name, appreciation:list[0]?.projected_growth,dataPresent:true, title:'Stock Market'});
    } else {
      setIsLoading(false);
      setFinDetails([]);
      setData({ dataPresent:false});
    }
  };

  
  // Custom function to render the index
  const indexBodyTemplate = (rowData, options) => {
    return options.rowIndex + 1; // Row index starts from 0, so add 1 to start from 1
  };
  
  const curpriceTemplate = (rowData) => {
    return <span>{"$ " + formatNumber(rowData.current_price)}</span>;
  };
  const purpriceTemplate = (rowData) => {
    return <span>{"$ " + formatNumber(rowData.purchasePrice)}</span>;
  };
  const growthTemplate = (rowData) => {
    return <span>{ formatNumber(rowData.projected_growth) + " %"}</span>;
  };
  const changeTemplate = (rowData) => {
    return <span>{ formatNumber(rowData.percentage_change) + " %"}</span>;
  };
   const purdateTemplate = (rowData) => {
    const formattedDate = moment(rowData.purchase_date).format('MM-DD-YYYY');
    return <span>{formattedDate}</span>;
  };
   const handleAddFinancialModal = () => {
      if (!financialModal) {
        const payload = {
          description: "Financial",
        };
        insertLogs(payload);
      }
      setTitle("Add");
      setValues({
        userId:userId
      });
      setFinancialModal(!financialModal);
    };
    const renderFinancialModal = () => (
      <AddFinancials
        financialModal={financialModal}
        handleAddFinancialModal={handleAddFinancialModal}
        title={title}
        finDetails={finDetails}
        setFinDetails={setFinDetails}
        values={values}
        setValues={setValues}
        pdate={pdate}
      />
    );
    const setEditValues = (rowData) => {
      setTitle("Edit Financials");
     
      setValues({
        ...values,
        equity_name: rowData.equity_name,
        purchase_date: rowData.purchase_date,
        qty_owned: rowData.qty_owned,
        purchasePrice: rowData.purchasePrice,
        //current_price: rowData.current_price,
        inv_value: rowData.inv_value, 
        //current_value: rowData.current_value,
        //percentage_change: rowData.percentage_change,
        //gain_loss: rowData.gain_loss,
        projected_growth: rowData.projected_growth,
        annualIncome:rowData.annualIncome,
        id: rowData.id,
        userId:userId
      });
      setPdate(rowData.purchase_date);
      setFinancialModal(!financialModal);
     
      setData({ purchasePrice:rowData?.purchasePrice, appreciation:rowData?.projected_growth,dataPresent:true});
  
    };
  const actionTemplate = (rowData, options) => {
    const menu = React.createRef();

    const handleEdit = () => {
      setEditValues(rowData);
     
    };

    const handleDelete = async () => {
      const details = await deleteFinancials(rowData.id,userId);
      if (details) {
        showSuccess("Stock Record deleted successfully");
        // insert settings value
        setIsLoading(false);
        setTimeout(() => {
          fetchFinancials();
        }, 1000);
      } else {
        showError("Error");
      }
    };
    const items = [
      { label: "Edit", command: handleEdit },
      { label: "Delete", command: handleDelete }
    ];

    return (
      <>
        <Menu model={items} popup ref={menu} />

        <i
          style={{ cursor: "pointer" }}
          className="pi pi-ellipsis-v"
          onClick={(event) => {
            menu.current.toggle(event);
          }}
        ></i>
      </>
    );
  };
  // Custom body template to render hyperlinks
  const linkTemplate = (rowData, options) => {
    return (
      <span
        style={{
          textAlign: "center",
       //   whiteSpace: "pre-line",
          cursor: "pointer",
        }}
        onClick={() => setEditValues(rowData)}
      >
        {rowData.equity_name}
      </span>
    );
  };
  return (
    <div style={{ margin: "2rem" }}>
      {isLoading && <Loading />}
      <div className="col-2"></div>
      <div className="grid">
        <div className="bannerStyle col-12" style={{textAlign:"start"}}>Stock Market</div>
      </div>
        <div className="col-12" style={{textAlign:"end"}}>
          <Button
            type="button"
            label="Add Stock"
            className="p-button-raised p-button-warning mr-4"
            onClick={handleAddFinancialModal}
          />
        </div>
      <div>
        <Toast ref={toast} className="ToastMessage" />

        <DataTable
          value={finDetails}
          className="propertyTable mt-3"
          responsiveLayout="scroll"
          emptyMessage="Please add your stock market information"
          scrollHeight="65vh"
          scrollDirection="both"
          rows={10}
          loading={isLoading}
          paginator={finDetails.length > 10}
          rowHover
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink   CurrentPageReport"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <Column body={indexBodyTemplate} header="ID"/>
          <Column
            sortable
            field="equity_name"
            header="Equity"
            style={{ width: "25%" }}
            body={linkTemplate}
          />
            <Column
            sortable
            field="purchase_date"
            header="Purchase Date"
            style={{ width: "25%" }}
            body={purdateTemplate}
          />
          <Column
            sortable
            field="qty_owned"
            header="Quantity Owned"
            style={{ width: "25%" }}
          />
           <Column
            field="purchasePrice"
            className="no-wrap"
            header="Purchase Price "
            body={purpriceTemplate}
          />
          
          <Column
            field="projected_growth"
            header="Projected Growth" body={growthTemplate}
          />

          <Column field="Actions" body={actionTemplate} header="Actions" />
        </DataTable>
        {financialModal && renderFinancialModal()}
      </div>
    </div>
  );
};

export default Financials;
